
(function() {
  function initProductCarousel() {
    var $carousel = $('.carousel-media-slick');

    // Se non c'è nessun carosello nella pagina, esci
    if ($carousel.length === 0) return;

    // Se Slick è già inizializzato, distruggilo prima di reinizializzare
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
    }

    // Raccogli tutte le immagini nel carosello
    var $images = $carousel.find('img');
    var totalImages = $images.length;

    // Se non ci sono immagini, inizializza subito (potrebbe avere solo video)
    if (totalImages === 0) {
      activateSlick($carousel);
      return;
    }

    var loadedCount = 0;

    // Funzione che controlla se tutte le immagini sono pronte
    function onImageReady() {
      loadedCount++;
      if (loadedCount >= totalImages) {
        activateSlick($carousel);
      }
    }

    $images.each(function() {
      var img = this;
      // Se l'immagine è già completamente caricata (dalla cache ad esempio)
      if (img.complete && img.naturalWidth > 0) {
        onImageReady();
      } else {
        // Ascolta load ed error per non bloccarsi su immagini rotte
        $(img).one('load error', onImageReady);
      }
    });

    // Timeout di sicurezza: se dopo 5 secondi le immagini non si sono caricate, forza l'init
    setTimeout(function() {
      if (!$carousel.hasClass('slick-initialized')) {
        activateSlick($carousel);
      }
    }, 5000);
  }

  function activateSlick($carousel) {
    // Doppio check: evita doppia inizializzazione
    if ($carousel.hasClass('slick-initialized')) return;

    $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M201.4 297.4C188.9 309.9 188.9 330.2 201.4 342.7L361.4 502.7C373.9 515.2 394.2 515.2 406.7 502.7C419.2 490.2 419.2 469.9 406.7 457.4L269.3 320L406.6 182.6C419.1 170.1 419.1 149.8 406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3L201.3 297.3z"/></svg></i></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M439.1 297.4C451.6 309.9 451.6 330.2 439.1 342.7L279.1 502.7C266.6 515.2 246.3 515.2 233.8 502.7C221.3 490.2 221.3 469.9 233.8 457.4L371.2 320L233.9 182.6C221.4 170.1 221.4 149.8 233.9 137.3C246.4 124.8 266.7 124.8 279.2 137.3L439.2 297.3z"/></svg></button>',
      responsive: [
          {
          breakpoint: 768,
          settings: {
              arrows: false
            }
          }
        ]
    });
  }

  // Inizializzazione al primo caricamento della pagina
  $(document).ready(function() {
    initProductCarousel();
  });

  // Gestisci la navigazione Shopify (preview di sviluppo / turbolinks)
  // Shopify emette questi eventi quando il contenuto della sezione viene ricaricato
  $(document).on('shopify:section:load', function() {
    initProductCarousel();
  });

  // Fallback: se il DOM cambia (ad es. navigazione AJAX), MutationObserver
  // rileva l'inserimento di un nuovo .carousel-media-slick
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType === 1) {
            if ($(node).hasClass('carousel-media-slick') || $(node).find('.carousel-media-slick').length > 0) {
              // Piccolo delay per assicurarsi che il DOM sia completo
              setTimeout(initProductCarousel, 100);
              return;
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();